import { createReducer, on } from "@ngrx/store"
import {
  ClearSearchedFoodList,
  ClearSearchedPhysicalActivityList,
  ClearState, FetchActivityTypeFailure, FetchActivityTypeRequest, FetchActivityTypeSuccess,
  FetchColorTypeFailure,
  FetchColorTypeRequest,
  FetchColorTypeSuccess,
  FetchDailyMealAndDrinkTrackerFailure,
  FetchDailyMealAndDrinkTrackerRequest,
  FetchDailyMealAndDrinkTrackerSuccess,
  FetchDailyScreenActivityFailure,
  FetchDailyScreenActivityRequest,
  FetchDailyScreenActivitySuccess,
  FetchDataAccordingToDaySelectedFailure,
  FetchDataAccordingToDaySelectedRequest,
  FetchDataAccordingToDaySelectedSuccess,
  FetchMealTypeFailure,
  FetchMealTypeRequest,
  FetchMealTypeSuccess,
  FetchPhysicalDailyActivityFailure,
  FetchPhysicalDailyActivityRequest,
  FetchPhysicalDailyActivitySuccess, FetchScreenTypeFailure, FetchScreenTypeRequest, FetchScreenTypeSuccess,
  FetchSearchedDailyMealAndDrinkTrackerListFailure,
  FetchSearchedDailyMealAndDrinkTrackerListRequest,
  FetchSearchedDailyMealAndDrinkTrackerListSuccess,
  FetchSearchedPhysicalDailyActivityFailure,
  FetchSearchedPhysicalDailyActivityRequest,
  FetchSearchedPhysicalDailyActivitySuccess,
  FetchTodTypeFailure,
  FetchTodTypeRequest,
  FetchTodTypeSuccess,
  FetchWeekDaysDetailsFailure,
  FetchWeekDaysDetailsRequest,
  FetchWeekDaysDetailsSuccess
} from './my-journal.actions'
import { FetchWeekDaysDetailsModel, foodIntake, physicalActivity, screenTimeActivity } from "../model/list.model"
import { DropdownOption } from "src/app/models/dropdown-option.model"

export interface MyJournalState {
  dummy: boolean,
  dailyMeal: {
    list?: any[],
    total: number,
    pageNumber: number,
    limit: number,
    hasNext: boolean,
    hasPrev: boolean,
    loading: boolean
  },
  dailyPhysical: {
    list?: any[],
    total: number,
    pageNumber: number,
    limit: number,
    hasNext: boolean,
    hasPrev: boolean,
    loading: boolean
  },
  dailyScreen: {
    list?: any[],
    total: number,
    pageNumber: number,
    limit: number,
    hasNext: boolean,
    hasPrev: boolean,
    loading: boolean
  },
  searchedDailyMeal: {
    list?: any[],
    total: number,
    pageNumber: number,
    limit: number,
    hasNext: boolean,
    hasPrev: boolean,
    loading: boolean
  },
  searchedDailyPhysical: {
    list?: any[],
    total: number,
    pageNumber: number,
    limit: number,
    hasNext: boolean,
    hasPrev: boolean,
    loading: boolean
  },
  weekDetails: {
    loading: boolean,
    details: FetchWeekDaysDetailsModel['response']['data']
  },
  foodIntake: foodIntake[],
  physicalActivity: physicalActivity[],
  screenTimeActivity: screenTimeActivity[],
  loading: boolean,
  totalRl: number,
  totalPa: number,
  totalSt: number,
  mealType: {
    loading: boolean,
    list: DropdownOption[]
  },
  todType: {
    loading: boolean,
    list: DropdownOption[]
  },
  colorType: {
    loading: boolean,
    list: DropdownOption[]
  },
  screenType: {
    loading: boolean,
    list: DropdownOption[]
  },
  activityType: {
    loading: boolean,
    list: DropdownOption[]
  },
}

const initialState: MyJournalState = {
  dummy: false,
  dailyMeal: {
    list: [],
    total: 0,
    pageNumber: 0,
    limit: 0,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  dailyPhysical: {
    list: [],
    total: 0,
    pageNumber: 0,
    limit: 0,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  dailyScreen: {
    list: [],
    total: 0,
    pageNumber: 0,
    limit: 0,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  searchedDailyMeal: {
    list: [],
    total: 0,
    pageNumber: 0,
    limit: 0,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  searchedDailyPhysical: {
    list: [],
    total: 0,
    pageNumber: 0,
    limit: 0,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  weekDetails: {
    details: null,
    loading: false
  },
  foodIntake: [],
  physicalActivity: [],
  screenTimeActivity: [],
  loading: false,
  totalRl: 0,
  totalPa: 0,
  totalSt: 0,
  mealType: {
    list: [],
    loading: false
  },
  todType: {
    list: [],
    loading: false
  },
  colorType: {
    list: [],
    loading: false
  },
  screenType: {
    list: [],
    loading: false
  },
  activityType: {
    list: [],
    loading: false
  },
}

export const reducer = createReducer(
  initialState,

  on(FetchDailyMealAndDrinkTrackerRequest, (state) => ({
    ...state, dailyMeal: { ...state.dailyMeal, loading: true }
  })),

  on(FetchDailyMealAndDrinkTrackerSuccess, (state, props) => ({
    ...state, dailyMeal: { ...props?.payload, loading: false }
  })),

  on(FetchDailyMealAndDrinkTrackerFailure, (state) => ({
    ...state, dailyMeal: { ...state.dailyMeal, loading: false }
  })),

  on(FetchPhysicalDailyActivityRequest, (state) => ({
    ...state, dailyPhysical: { ...state.dailyPhysical, loading: true }
  })),

  on(FetchPhysicalDailyActivitySuccess, (state, props) => ({
    ...state, dailyPhysical: { ...props?.payload, loading: false }
  })),

  on(FetchPhysicalDailyActivityFailure, (state) => ({
    ...state, dailyPhysical: { ...state.dailyPhysical, loading: false }
  })),

  on(FetchDailyScreenActivityRequest, (state) => ({
    ...state, dailyScreen: { ...state.dailyScreen, loading: true }
  })),

  on(FetchDailyScreenActivitySuccess, (state, props) => ({ ...state, dailyScreen: { ...props?.payload, loading: false } })),

  on(FetchDailyScreenActivityFailure, (state) => ({
    ...state, dailyScreen: { ...state.dailyScreen, loading: false }
  })),

  on(FetchSearchedDailyMealAndDrinkTrackerListRequest, (state, props) => ({
    ...state, searchedDailyMeal: {
      ...state.searchedDailyMeal,
      loading: true,
      ...(props?.payload.pageNumber ?
        props?.payload.pageNumber > 1 ?
          {
            list: [...state.searchedDailyMeal.list]
          } :
          { list: [] } :
        { list: [] })
    }
  }
  )),

  on(FetchSearchedDailyMealAndDrinkTrackerListSuccess, (state, props) => ({
    ...state, searchedDailyMeal: {
      ...props?.payload,
      loading: false,
      ...(props?.payload.pageNumber ? props?.payload.pageNumber > 1 ? {
        list: [...state.searchedDailyMeal.list, ...props?.payload.list]
      } : { list: [...props?.payload.list] } : {
        list: [...props?.payload.list]
      })
    }
  })),

  on(FetchSearchedDailyMealAndDrinkTrackerListFailure, (state) => ({
    ...state, searchedDailyMeal: { ...initialState.searchedDailyMeal, loading: false }
  })),

  on(ClearSearchedFoodList, (state) => ({
    ...state, searchedDailyMeal: {
      ...initialState.searchedDailyMeal
    }
  })),

  on(FetchSearchedPhysicalDailyActivityRequest, (state, props) => ({
    ...state, searchedDailyPhysical: {
      ...state.searchedDailyPhysical, loading: true,
      ...(props?.payload.pageNumber ?
        props?.payload.pageNumber > 1 ?
          { list: [...state.searchedDailyPhysical.list] } :
          { list: [] } :
        { list: [] })
    }
  }
  )),

  on(FetchSearchedPhysicalDailyActivitySuccess, (state, props) => ({
    ...state, searchedDailyPhysical: {
      ...props?.payload,
      loading: false,
      ...(props?.payload.pageNumber ? props?.payload.pageNumber > 1 ? {
        list: [...state.searchedDailyPhysical.list, ...props?.payload.list]
      } : { list: [...props?.payload.list] } : {
        list: [...props?.payload.list]
      })
    }
  })),

  on(FetchSearchedPhysicalDailyActivityFailure, (state) => ({
    ...state, searchedDailyPhysical: { ...state.searchedDailyPhysical, loading: false }
  })),

  on(ClearSearchedPhysicalActivityList, (state) => ({
    ...state,
    searchedDailyPhysical: {
      ...initialState.searchedDailyPhysical
    }
  })),

  on(FetchWeekDaysDetailsRequest, (state) => (
    { ...state, weekDetails: { ...state.weekDetails, loading: true } }
  )),

  on(FetchWeekDaysDetailsSuccess, (state, props) => ({
    ...state,
    weekDetails: { loading: false, details: props?.payload }
  })),

  on(FetchWeekDaysDetailsFailure, (state) => ({ ...state, weekDetails: { ...state.weekDetails, loading: false } })),

  on(FetchDataAccordingToDaySelectedRequest, (state) => ({
    ...state,
    loading: true,
    foodIntake: [],
    physicalActivity: [],
    screenTimeActivity: [],
    totalPa: null,
    totalRl: null,
    totalSt: null
  })),

  on(FetchDataAccordingToDaySelectedSuccess, (state, props) => {
    return ({
      ...state,
      loading: false,
      foodIntake: props?.payload.foodIntake,
      physicalActivity: props?.payload.physicalActivity,
      screenTimeActivity: props?.payload.screenTime,
      totalPa: props?.payload.paTotal,
      totalRl: props?.payload.rlTotal,
      totalSt: props?.payload.stTotal

    })
  }),
  on(FetchDataAccordingToDaySelectedFailure, (state) => ({ ...state, loading: false })),

  on(FetchMealTypeRequest, (state) => ({ ...state, mealType: { loading: true, list: [] } })),

  on(FetchMealTypeSuccess, (state, props) => ({ ...state, mealType: { loading: false, list: props?.payload.list } })),

  on(FetchMealTypeFailure, (state) => ({ ...state, mealType: { loading: false, list: [] } })),

  on(FetchTodTypeRequest, (state) => ({ ...state, todType: { loading: true, list: [] } })),

  on(FetchTodTypeSuccess, (state, props) => ({ ...state, todType: { loading: false, list: props?.payload.list } })),

  on(FetchTodTypeFailure, (state) => ({ ...state, todType: { loading: false, list: [] } })),

  on(FetchColorTypeRequest, (state) => ({ ...state, colorType: { loading: true, list: [] } })),

  on(FetchColorTypeSuccess, (state, props) => ({ ...state, colorType: { loading: false, list: props?.payload.list } })),

  on(FetchColorTypeFailure, (state) => ({ ...state, colorType: { loading: false, list: [] } })),

  on(ClearState, (state) => initialState),

  // FetchScreenTypeRequest
  on(FetchScreenTypeRequest, (state) => ({
    ...state,
    screenType: {
      loading: true,
      list: []
    }
  })),
  on(FetchScreenTypeSuccess, (state, props) => ({
    ...state,
    screenType: {
      loading: false,
      list: props?.payload.list
    }
  })),
  on(FetchScreenTypeFailure, (state) => ({
    ...state,
    screenType: {
      loading: false,
      list: []
    }
  })),

  // FetchActivityTypeRequest
  on(FetchActivityTypeRequest, (state) => ({
    ...state,
    activityType: {
      loading: true,
      list: []
    }
  })),
  on(FetchActivityTypeSuccess, (state, props) => ({
    ...state,
    activityType: {
      loading: false,
      list: props?.payload.list
    }
  })),
  on(FetchActivityTypeFailure, (state) => ({
    ...state,
    activityType: {
      loading: false,
      list: []
    }
  })),
)
